import { AttachmentView } from '../../core/hub-types';
import { PhotoLayout, photoGrid } from '../../core/photo-grid';
import { FileObject } from 'src/app/core/interfaces';

export interface PhotoTile {
  attachment: AttachmentView;
  /** position among all of the message's photos, where the viewer opens */
  index: number;
  label: string;
  /** on the fourth tile of a long message: how many photos it stands for; 0 elsewhere */
  more: number;
}

export interface MessagePhotos {
  layout: PhotoLayout;
  tiles: PhotoTile[];
  /** every photo of the message, which the viewer pages through */
  all: AttachmentView[];
}

/** A photo drawn in the thread. Most browsers cannot show HEIC, so it stays a file chip. */
export function isInlinePhoto(a: AttachmentView): boolean {
  return a.contentType.startsWith('image/') && a.contentType !== 'image/heic';
}

/** A message's photos laid out as one grid; its other files are drawn below it. */
export function messagePhotos(attachments: readonly AttachmentView[] | null | undefined): MessagePhotos {
  const all = (attachments ?? []).filter(isInlinePhoto);
  const grid = photoGrid(all.map((a) => a.id));
  const tiles = grid.shown.map((_, index) => {
    const more = index === 3 ? grid.more : 0;
    return { attachment: all[index], index, more, label: more ? `Show all ${all.length} photos` : all[index].fileName };
  });
  return { layout: grid.layout, tiles, all };
}

/** What the image viewer is opened with: all the photos, at the tapped one. */
export function photoViewerData(fileObjects: FileObject[], index: number) {
  const at = index >= 0 && index < fileObjects.length ? index : 0;
  return { fileObjects, selectedFile: fileObjects[at], index: at, enableEditing: false };
}
